import axios from "axios";
import { globalDB } from "../store/globalStore";
import { getRandomID } from "../components/mapping/map/helpers";

export const setUserIP = async () => {
  try {
    // TODO: retry logic
    const ip = await axios.get("https://geolocation-db.com/json/");
    const uuid = getRandomID();
    const ipAddress = ip.data.IPv4;
    globalDB.userData.count((count) => {
      if (count === 0) {
        globalDB.userData.put({
          id: 1,
          user_id: uuid,
          ip: ipAddress ?? "no ip",
        });
      } else {
        globalDB.userData.where("id").equals(1).modify({ ip: ipAddress });
      }
    });
  } catch (e) {
    // TODO: report this error.
    undefined;
  }
};
